var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7492 0.40459C13.4208 0.109023 12.915 0.135646 12.6194 0.464054C12.3238 0.792462 12.3505 1.29829 12.6789 1.59386L16.1289 4.69886L10.214 4.69893C5.90619 4.69897 2.41406 8.19114 2.41406 12.4989V18.9998C2.41406 19.4416 2.77223 19.7998 3.21406 19.7998C3.65589 19.7998 4.01406 19.4416 4.01406 18.9998L4.01406 12.4989C4.01406 9.07479 6.78986 6.29897 10.214 6.29893L16.283 6.29886L12.6484 9.93354C12.3359 10.246 12.3359 10.7525 12.6484 11.0649C12.9608 11.3773 13.4673 11.3773 13.7797 11.0649L18.7052 6.13944C19.0698 5.77483 19.0541 5.17903 18.6709 4.83408L13.7492 0.40459Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.9accf153f6b7fdd9a3190cc49c95b532.svg";
export { ForwardRef as ReactComponent };